import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

import VueMarkdown from 'vue-markdown'
Vue.component('vue-markdown', VueMarkdown);

import commentComponent from '../component/comment';
Vue.component('comment', commentComponent);
new Vue({
    el: '#comments-block'
});
